import React from 'react';
import { errorLogService } from '../services/errorLogService';
import { detectActiveExtensions } from '../config/errorLoggingInit';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null, detectedExtensions: [] };
  }

  static getDerivedStateFromError(error) {
    // Mantém log técnico no console para visibilidade — SEM enviar ao backend aqui
    // (o envio é feito em componentDidCatch com mais contexto)
    console.error('[ERROR_BOUNDARY] getDerivedStateFromError:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log técnico completo no console
    console.error('[ERROR_BOUNDARY] componentDidCatch - Error:', error);
    console.error('[ERROR_BOUNDARY] componentDidCatch - Stack:', error.stack);
    console.error('[ERROR_BOUNDARY] componentDidCatch - ComponentStack:', errorInfo.componentStack);

    // Detecta extensões ativas no momento do crash para contexto de diagnóstico
    const detectedExtensions = detectActiveExtensions();

    this.setState({ error, errorInfo, detectedExtensions });

    // Envia ao backend com contexto completo (stack + componentStack + extensões detectadas)
    const enrichedError = Object.assign(new Error(error.message), {
      stack: error.stack,
    });
    errorLogService.logError(enrichedError, null, {
      componentStack: errorInfo.componentStack,
      detectedExtensions,
    }).catch(() => {});
  }

  render() {
    if (this.state.hasError) {
      const { detectedExtensions } = this.state;

      const isDomExtensionError =
        this.state.error?.message?.includes('removeChild') ||
        this.state.error?.message?.includes('Node') ||
        this.state.error?.message?.includes('insertBefore');

      let titulo = 'Algo deu errado';
      let descricao = 'Ocorreu um erro inesperado. Por favor, recarregue a página.';

      if (isDomExtensionError || detectedExtensions.length > 0) {
        titulo = 'Interferência detectada no navegador';

        if (detectedExtensions.length > 0) {
          const nomes = detectedExtensions.join(', ');
          descricao = `Uma extensão do seu navegador (${nomes}) está modificando o conteúdo da página e causou um conflito. Desative-a temporariamente ou recarregue a página.`;
        } else {
          descricao =
            'Uma extensão do seu navegador (como Google Translate, Grammarly ou um bloqueador de anúncios) pode estar interferindo. Tente desabilitá-las ou recarregue a página.';
        }
      }

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '40px 20px',
            fontFamily: 'sans-serif',
            textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
          <h2 style={{ color: '#333', marginBottom: '12px', fontWeight: 600 }}>{titulo}</h2>
          <p style={{ color: '#666', maxWidth: '480px', lineHeight: '1.6', marginBottom: '24px' }}>
            {descricao}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 28px',
              backgroundColor: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontSize: '15px',
              cursor: 'pointer',
              fontWeight: 500,
            }}
          >
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
